<template>
    <v-footer app fixed class="footer">
        <span>&copy; {{currentYear}} Just Works bvba</span>
    </v-footer>
</template>

<script>
export default {
  name: "MainFooter",
  data: () => ({
    currentYear: new Date().getFullYear()
  })
};
</script>

<style>
.footer {
  padding-left: 10px;
}
</style>
